import React from "react";
// import PropTypes from "prop-types";
import { uniqueId } from "lodash";
import { Form } from "react-bootstrap";
import clsx from "clsx";
import styles from "./styles/Question.module.css";

const MultipleChoiceQuestion = (props) => {
  const {
    options,
    userAnswer,
    onChange,
    // correctAnswer,
    // isCorrect,
    showAnswer,
  } = props;

  // state

  // variables

  // logics before hooks

  // hooks

  // logics
  const handleChange = (optId) => {
    if (userAnswer.includes(optId)) {
      const newAnswer = userAnswer.filter((ans) => ans !== optId);
      onChange(newAnswer);
    } else {
      onChange([...userAnswer, optId]);
    }
  };

  // UI partials

  // effects

  const questionId = uniqueId();
  // render
  return (
    <Form className="">
      {options.map((opt) => {
        let className = "";
        if (showAnswer && userAnswer.includes(opt.id)) {
          if (opt.isCorrectAnswer) {
            className = styles.correctAnswer;
          } else {
            className = styles.wrongAnswer;
          }
        }

        if (showAnswer && opt.isCorrectAnswer) {
          className = styles.correctAnswer;
        }

        return (
          <Form.Check
            key={opt.id}
            type="checkbox"
            label={opt.title}
            name={questionId}
            id={opt.id}
            checked={userAnswer.includes(opt.id)}
            onChange={() => {
              !showAnswer && handleChange(opt.id);
            }}
            className={clsx(className, styles.option)}
          />
        );
      })}
    </Form>
  );
};

/* required: display name */
MultipleChoiceQuestion.displayName = "MultipleChoiceQuestion";

/* required: props types */
MultipleChoiceQuestion.propTypes = {};

/* required: default props */
MultipleChoiceQuestion.defaultProps = {};

export { MultipleChoiceQuestion as MultipleChoiceQuestion };
